import { useIntl } from "react-intl";

import { useLocalizedHref } from "@/libraries/web-framework";
import { LogoV2 } from "@/libraries/wpl/foundations/src";
import { ProductPageSubNav } from "@/patterns/global-nav-v2/src";

const JiraLogo = () => <LogoV2 brand="jira" type="logo" appearance="brand" />;

const JiraSoftwareNavV2 = () => {
    const intl = useIntl();

    const links = [
        {
            globalLinksKey: "features",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.features",
                defaultMessage: "Features"
            }),
            hasSubnav: false,
            productKey: "jira",
            href: useLocalizedHref("/software/jira/features")
        },
        {
            globalLinksKey: "productGuide",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.product-guide",
                defaultMessage: "Product guide"
            }),
            hasSubnav: false,
            productKey: "jira",
            href: useLocalizedHref(
                "/software/jira/guides/getting-started/introduction"
            )
        },
        {
            globalLinksKey: "templates",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.templates",
                defaultMessage: "Templates"
            }),
            hasSubnav: false,
            productKey: "jira",
            href: useLocalizedHref("/software/jira/templates")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.pricing",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jira",
            href: useLocalizedHref("/software/jira/pricing")
        },
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                id: "software-jira.navbar.enterprise",
                defaultMessage: "Enterprise"
            }),
            hasSubnav: false,
            productKey: "jira",
            href: useLocalizedHref("/software/jira/enterprise")
        }
    ];

    return (
        <ProductPageSubNav
            productLogoUrl={useLocalizedHref("/software/jira")}
            productLogo={<JiraLogo />}
            productLogoAriaLabel={intl.formatMessage({
                id: "wacJiraSoftwareNavigation.logo-label",
                defaultMessage: "Jira Software logo"
            })}
            mobileCtaText={intl.formatMessage({
                id: "JiraeSoftwarePageTemplate.navbar.getitfree",
                defaultMessage: "Get it free"
            })}
            mobileCtaUrl={useLocalizedHref(
                "/try/cloud/signup?bundle=jira-software&edition=free"
            )}
            mobileLogo={<JiraLogo />}
            navigationTrynowCtaText={intl.formatMessage({
                id: "JiraFeatureSoftwarePageTemplate.heroCTA",
                defaultMessage: "Get it free"
            })}
            navigationTrynowCtaUrl={useLocalizedHref(
                "/try/cloud/signup?bundle=jira-software&edition=free"
            )}
            productPageNavLinks={links}
            mobileLinksSections={[
                {
                    key: "mobile-jira",
                    mobileLinksProps: links
                }
            ]}
        />
    );
};

JiraSoftwareNavV2.displayName = "JiraSoftwareNavV2";

export default JiraSoftwareNavV2;
